<template>
  <Link
    v-bind="$props"
    :icon="
      loading 
        ? 'el-icon-loading'
        : icon
    "
    @click="$emit('click')">
    <slot />
  </Link>
</template>

<script>
import { Link } from 'element-ui';
export default {
  props: {
    ...Link.props,
    loading: Boolean
  },
  components: {
    Link
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Element/ElLink.vue